import { Location } from '@angular/common';
// Angular modules.
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
// Third-party modules.
import { TranslateService } from '@ngx-translate/core';
import { CalendarNavState } from 'app/interfaces/calendar.interface';
@Component({
	selector: 'app-mobappointments-options',
	templateUrl: './mobappointments-options.component.html',
	styleUrls: ['./mobappointments-options.component.scss'],
})
export class MobAppointmentsOptionsComponent implements OnInit {
	@Output() changeScreen: EventEmitter<string> = new EventEmitter<string>();
	@Input() returnTo: CalendarNavState;

	// Constructor method.
	constructor(
		protected location: Location,
		protected route: ActivatedRoute,
		protected router: Router,
		protected translate: TranslateService
	) {}

	// On init.
	public ngOnInit(): void {}

	// Show a given screen.
	public showScreen(screen: string): void {
		this.changeScreen.emit(screen);
	}

	// Navigate.
	public goToPage(page: string): void {
		switch (page.toLowerCase()) {
			// Home =====================================================================
			case '/':
			case 'calendar':
			case 'dashboard':
			case 'home':
				this.router.navigate(['/calendar'], { state: { ...this.returnTo } });
				break;
			case 'availabilities':
				this.router.navigate(['/availabilities'], {
					state: { returnTo: 'appointments' },
				});
				break;
		}
	}
}
